export const roundDownToDecimalPlace = (value: number, fractionDigits: number = 1) => {
	return Math.floor(value * (10 * fractionDigits)) / (10 * fractionDigits);
};

export const multiply = (...numbers: number[]) => {
	return numbers.reduce((acc, val) => {
		return (acc * (val * 100)) / 100;
	}, 1)
};

export const parseFloatNumber = (value: string): number => {
	return +value.replace(",", ".");
};

export const parseFloatString = (value: string): string => {
	return value.replace(",", ".");
};

export const ceilHalf = (value: number): number => {
	return Math.ceil(value * 2) / 2;
};

export const preciseSubtract = (minuend: number, subtrahend: number, fractionDigits: number = 2): number => {
	const factor = 10 ** fractionDigits;
	return (Math.round(minuend * factor) - Math.round(subtrahend * factor)) / factor;
};
